"use client";

import Link from "next/link";
import { ChevronRight, Home } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  homeHref?: string;
}

/**
 * SEO-friendly Breadcrumbs Component
 * Schema.org BreadcrumbList markup ile
 */
export function Breadcrumbs({
  items,
  className = "",
  homeHref = "/",
}: BreadcrumbsProps) {
  const allItems = [{ label: "Ana Sayfa", href: homeHref }, ...items];

  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center text-sm text-gray-600 ${className}`}
    >
      <ol
        className="flex items-center flex-wrap gap-1"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {allItems.map((item, index) => (
          <li
            key={item.href}
            className="flex items-center"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            {index > 0 && (
              <ChevronRight className="w-4 h-4 mx-1 text-gray-400" />
            )}

            {index === allItems.length - 1 ? (
              // Son item - aktif sayfa
              <span
                className="text-gray-900 font-medium"
                itemProp="name"
                aria-current="page"
              >
                {index === 0 && <Home className="w-4 h-4 inline mr-1" />}
                {item.label}
              </span>
            ) : (
              // Link items
              <Link
                href={item.href}
                className="hover:text-indigo-600 transition-colors"
                itemProp="item"
              >
                <span itemProp="name">
                  {index === 0 && <Home className="w-4 h-4 inline mr-1" />}
                  {item.label}
                </span>
              </Link>
            )}

            <meta itemProp="position" content={String(index + 1)} />
          </li>
        ))}
      </ol>
    </nav>
  );
}
